export enum ConfirmationDialogResult {
  CONFIRM = 'confirm',
  CANCEL = 'cancel',
  CLOSE = 'close',
}
